import React, { useState, useEffect, useContext } from "react";
import "./css.css";
import { Link } from "react-router-dom";
import wsp from "../../img/wsp.png";
import mercado from "../../img/mercado-pago.png";
import 'firebase/database';
import firebase from 'firebase/app';
import ProductsContext from '../Context/AppContext';
import getType from '../getTypes';

export default function ShowProduct(props) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [mainImg, setMainImg] = useState('');
  const [imgs, setImgs] = useState(null);
  const {products} = useContext(ProductsContext);

  useEffect(() => {

    const getImgs = async (id, cantImg, urlMain) => {
      if(cantImg && cantImg > 0){
        var newImgs = [];
            for(var i = 0; i < cantImg; i++){
              const img = await firebase.storage().ref(`pics/${id}`).child(`${i}`).getDownloadURL();
              newImgs.push({url:img, select: img === urlMain, id:i, load:false})
            }
        setImgs(newImgs);
      }
    }

    const getProduct = async () => {
      try{
        const db = firebase.database().ref('/products');
        const product = await db.orderByChild("_id").equalTo(parseInt(props.match.params.id)).once('value');
          if(product.val() !== null){
            const theProduct = product.val()[Object.getOwnPropertyNames(product.val())[0]];
            setData(theProduct)
            setLoading(false);
            setMainImg(theProduct.img);
            getImgs(theProduct._id, theProduct.cantImg, theProduct.img)
          }
          else
            setData(null)
          setLoading(false);
      }
      catch (error){
        console.log(error)
      }}
    if(products !== null){
      const obj = products.find(product => product._id === parseInt(props.match.params.id));
      setData(obj);
      setMainImg(obj.img);
      getImgs(obj._id, obj.cantImg, obj.img);
      setLoading(false);
      window.scrollBy(0, 0);
    }
    else 
     getProduct(); 
  }, [props.match.params.id, products])

  const handleChangeMainImg = (e) => {
    var newImgs = [];
    for(const i of imgs){
      if(i.id === parseInt(e.target.name)){
        setMainImg(i.url);
        i.select = true;
      }
      else
        i.select = false;
        newImgs.push(i);
    }
    setImgs(newImgs);
  }

  const handleLoadImg = (e) => {
    let newImgs = [...imgs];
    newImgs[parseInt(e.target.name)].load = true;
    setImgs(newImgs);
  }

  if (loading) return <div className="cargando"></div>;
  else
    return (
      <div className="max-width">
        <Link to="/" className="button back">
          Volver al listado
        </Link>
        {data === null ? <div>Producto no encontrado.</div>
        :
        <div className="showproduct">
        <h3 className="name-showproduct">{data.name ? data.name : getType(data.category)}</h3>
          <div className="content-img-imgsmin">
            <img
              className="img-showproduct"
              src={mainImg}
              alt="Imagen del producto"
            />
            <div className="content-img-selects">
              {imgs && imgs.map((i) => 
              <div key={i.id} className="img-min">
                <div className={i.load ? "invisible" : "cargando"}></div>
                <img
                src={i.url} 
                name={i.id}
                onClick={handleChangeMainImg}
                onLoad={handleLoadImg}
                className={i.load ? i.select ? "img-min selected" : "img-min" : "invisible"} 
                alt="Imagen del product"/>
                </div>
                )}
                {!imgs && <div className="cargando"></div>}
              </div>
            </div>
            <div className="info-showproduct">
                {data.sizes &&
              <div className="sizes-showproduct">
                Talles disponibles:
                  {data.sizes.map((size, index) => (
                    <b key={index}>{index === 0 ? size : ", " + size}</b>
                  ))}
              </div>
              }
          </div>
            <p className="price-showproduct">${data.price}</p> 
            <div className="send">
              {data.category !== "accesory" && data.category !== "boxer" && data.category !== "fragrance"?
              <p>
              <span role="img" aria-label="dollar banknote">💵</span>Pago contado efectivo <span className="efec-line">${data.price}</span> <b>${(data.price * 0.90).toFixed(2)}</b></p>
            :<p>El descuento en efectivo no aplica a accesorios/boxers/perfumes</p>
            }
          </div>
          <div className="send">
            <span role="img" aria-label="credit card">💳</span>
            <p>Hasta 3 cuotas sin interés de <b>${(data.price / 3).toFixed(2)}</b></p>
          </div>
          <div className="send">
            <span role="img" aria-label="minibus">🚐</span>
            <p> Envío GRATIS a domicilio (DOLORES)</p>
          </div>
            <a
              href={
                "https://wa.me/5492245427854?text=Hola, te consulto por esta prenda https://newface-dolores.web.app/products/" +
                props.match.params.id
              }
              rel="noopener noreferrer"
              target="_blank"
              className="consult consult-showproduct"
            >
              <img className="wsp" src={wsp} alt="Whatsapp" />
              Consultar
            </a>
          </div>
      }
      <div className="content-info-showproduct">
      <p className="question"><b>¿Cómo compro?</b></p>
        <p className="question">¡Toca el botón de consultar y te contestaremos lo que necesites! <span role="img" aria-label="thumbs up">👍</span></p>
        <img src={mercado} alt="Envío" />
        </div>
      </div>
    );
}
